import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

import { userHasFeature } from '../../../../helpers/Features';

import SettingsEditButtons from '../EditButtons';
import SettingsItemsWrapper from '../Item/ItemsWrapper';
import AdminFileSizes from '../../../../containers/Admin/FileSizes';
import UpgradeBoard from '../../../UpgradeBoard';

const SettingsDownloading = (props) => {
  const {
    saving,
    handleSave,
    unsaved,
    title,
  } = props;

  return (
    <>
      <div className="settings-inner-content">
        <Row>
          <Col>
            <h3>{title}</h3>
          </Col>
        </Row>
        <SettingsItemsWrapper
          {...props}
        />
        {userHasFeature('file-sizes') ? (
          <AdminFileSizes {...props} />
        ) : (
          <UpgradeBoard feature="file-sizes" />
        )}
      </div>
      <SettingsEditButtons
        saving={saving}
        handleSave={handleSave}
        unsaved={unsaved}
      />
    </>
  );
};

SettingsDownloading.propTypes = {
  title: PropTypes.string.isRequired,
  handleSettingChange: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
  hiddenSettings: PropTypes.array.isRequired,
  errors: PropTypes.object.isRequired,
  setErrors: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  saving: PropTypes.bool.isRequired,
  handleSave: PropTypes.func.isRequired,
  unsaved: PropTypes.bool.isRequired,
};

export default SettingsDownloading;
